import { render } from "./MiniBasketArea.vue?vue&type=template&id=7752affa&scoped=true&ts=true"
import script from "./MiniBasketArea.vue?vue&type=script&lang=ts"
export * from "./MiniBasketArea.vue?vue&type=script&lang=ts"

import "./MiniBasketArea.vue?vue&type=style&index=0&id=7752affa&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7752affa"]])

export default __exports__